define("shared/components/shared/ui/blank-panel", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--blank" ...attributes>
    <div class={{@bgClass}}></div>
    <h2 class="o--blank__title">{{@title}}</h2>
    <p class="o--blank__desc">
      {{@description}}
    </p>
  </div>
  */
  {
    "id": "CgeaTyPR",
    "block": "[[[11,0],[24,0,\"o--blank\"],[17,1],[12],[1,\"\\n  \"],[10,0],[15,0,[30,2]],[12],[13],[1,\"\\n  \"],[10,\"h2\"],[14,0,\"o--blank__title\"],[12],[1,[30,3]],[13],[1,\"\\n  \"],[10,2],[14,0,\"o--blank__desc\"],[12],[1,\"\\n    \"],[1,[30,4]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"&attrs\",\"@bgClass\",\"@title\",\"@description\"],false,[]]",
    "moduleName": "shared/components/shared/ui/blank-panel.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});